import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import ErrorPage from './components/error';
import News from './pages/News';
import Home from './pages/Home';
import Facilities from './pages/Facilities';
import ActivitiesAndAttractions from './pages/ActivitiesAndAttractions';
import Calendar from './pages/Calendar';
import Contact from './pages/Contact';


const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'home',
        element: <Home />,
      },
      {
        path: 'news',
        element: <News />,
      },
      {
        path: 'facilities',
        element: <Facilities />
      },
      {
        path: 'activities and attractions',
        element: <ActivitiesAndAttractions />  
      },
      {
        path: 'calendar',
        element: <Calendar />
      },
      {
        path: 'contact',
        element: <Contact />
      },
      {
        path: '*',
        element: <Home />
      }
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
